export { default } from './ProductIngredients';
